<template>
    <div>
        <h5>{{transEdit('news')}}</h5>
        <template v-if="news.length > 0">
            <div v-for="nyhet in news" class="border rounded p-1 mt-1 pl-1 pr-1">
                <div class="d-flex align-items-start ">
                    <div class="flex pr-4 font-bold">
                        {{getFormattedDate(nyhet.created_at)}}:
                    </div>
                    <div class="flex pr-4">
                        {{nyhet.title}}
                    </div>
                </div>
            </div>
            <hr>
        </template>
        <template v-else>
            Det finns inga nyheter.
        </template>
    </div>
</template>

<script>
    export default {
        props: ['part'],
        name: "admin-dash-news",
        data: function () {
            return {
                news: [],
            };
        },
        methods: {
            getFormattedDate: function(date) {
                let _date = new moment(date);
                return _date.format('YYYY-MM-DD');
            },
        },
        mounted: function () {
            let self = this;
            axios.get(this.part.route_refresh)
                .then(function (response) {
                    self.news = response.data.news;
                })
                .catch(function (error) {
                });
        }
    }

</script>

<style scoped>

</style>
